import { render, staticRenderFns } from "./GiftProductSelectModal.vue?vue&type=template&id=2b02be58&"
import script from "./GiftProductSelectModal.vue?vue&type=script&lang=js&"
export * from "./GiftProductSelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b02be58')) {
      api.createRecord('2b02be58', component.options)
    } else {
      api.reload('2b02be58', component.options)
    }
    module.hot.accept("./GiftProductSelectModal.vue?vue&type=template&id=2b02be58&", function () {
      api.rerender('2b02be58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/modules/GiftProductSelectModal.vue"
export default component.exports